// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { displayFlexOnPrint, xScreen } from "@guestsupply/XDL/Utilities";
import { headerStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsHeader";
import { css } from "styled-components";

headerStyles.infoGridItem = {
    width: 12,
    css: css`
        align-items: flex-end;
        flex-wrap: wrap;
        column-gap: 30px;
        ${displayFlexOnPrint}
        @media print {
            justify-content: flex-start;
        }
        ${xScreen("lte", "sm")} {
            align-items: flex-start;
        }
        ${xScreen("lte", "xs")} {
            flex-direction: column;
        }
    `,
};
headerStyles.sharingStatus = {
    statusText: {},
    privateTooltip: {
        cssOverrides: {
            tooltipContainer: css`
                margin-left: -200px;
                &::after {
                    margin-left: 85px;
                }
                ${xScreen("lte", "xs")} {
                    margin-left: 0;
                }
            `,
        },
    },
};
headerStyles.totalText = {
    weight: "bold",
};
